export const ORIOLA_ADMIN_ROLE = "compensation_oriola_admin";
export const ORIOLA_VIEW_ROLE = "compensation_oriola_view";
export const PHARMA_CO_ROLE = "compensation_pharma_company_edit";
export const PHARMACY_ROLE = "compensation_pharmacy_view";
